import * as Immutable from "immutable";
import { SEVEN_DAYS_AGO, TODAY, TIME_ZONE } from "services/date-strings";
import { AnalyticsRequestParams } from "../legacyServices";

export class AnalyticsAnswersRequestParams extends AnalyticsRequestParams {
  /**
   * @returns {Immutable.Record.Class}
   * @class
   */
  static Filter = Immutable.Record({
    startDate: SEVEN_DAYS_AGO,
    endDate: TODAY,
    timeZone: TIME_ZONE,
    timeSeriesUnit: "day",
    language: Immutable.List(),
    platform: Immutable.List(),
    answerId: Immutable.List(),
    locked: undefined,
    browser: Immutable.List(),
    device: Immutable.List(),
    interactionType: Immutable.List()
  });
}

const initialState = {
  requestParams: new AnalyticsAnswersRequestParams({
    filter: new AnalyticsAnswersRequestParams.Filter()
  }),
  shouldRequestPreviousPeriod: false
};

/**
 * @param {Object} state
 * @param {{properties: Object}} action
 * @returns {Object}
 */
function updateFilter(state, action) {
  const {
    /** @type AnalyticsAnswersRequestParams */
    requestParams
  } = state;

  // Create new requestParams object using `action.properties`
  const newRequestParams = new AnalyticsAnswersRequestParams({
    ...requestParams,
    filter: new AnalyticsAnswersRequestParams.Filter({
      ...requestParams.filter.toObject(),
      ...action.properties
    })
  });

  return {
    ...state,
    requestParams: newRequestParams
  };
}

/**
 * @param {Object} state
 * @param {Object} action
 * @returns {Object}
 */
export default function analyticsAnswers(state = initialState, action) {
  switch (action.type) {
    case "UPDATE_ANALYTICS_ANSWERS_FILTER": {
      return updateFilter(state, action);
    }

    case "UPDATE_ANALYTICS_CONVERSATIONS_FILTER": {
      // Update filter if Conversation filter is updated
      const updatedAction = { ...action, properties: { ...action.properties } };

      if ("unit" in action.properties) {
        updatedAction.properties.timeSeriesUnit = action.properties.timeSeriesUnit;
      }

      return updateFilter(state, action);
    }

    case "UPDATE_ANALYTICS_ANSWERS_SHOULD_REQUEST_PREVIOUS_PERIOD": {
      return {
        ...state,
        shouldRequestPreviousPeriod: action.value
      };
    }

    default: {
      return state;
    }
  }
}
